/**
 * 指定された最大階層に基づいて階層リストを生成する関数。
 * タグセット管理画面に表示する階層数を制御する。
 *
 * @param {*} maxDepth - タグの最大階層
 * @returns {number[]} 0から始まる階層リスト
 * @example
 * // maxDepthが3以上の場合、0から5までのリストを生成
 * createDepthList(4);
 * // => [0, 1, 2, 3, 4, 5]
 */
const createDepthList = maxDepth => {
  const maxListDepth = maxDepth >= 3 ? 5 : 2;
  return Array.from({ length: maxListDepth + 1 }, (_, i) => i);
};

export default createDepthList;
